import React from "react";

import { WorkshopTestResult } from "../../types/WorkshopResult";

// Allows deeply nested tree chips (inside WSTestingProdTree) to request that the main page both
// select a product pairing and pre-apply a result filter in WSTestcaseRecording, without having to
// prop-drill a callback through every intermediate tree-level component.
export interface WSTestingChipFilterContextValue {
    selectResultFilter: (nodeHierarchy: string[], resultType: WorkshopTestResult) => void;
}

const setFilter: WSTestingChipFilterContextValue = {
    selectResultFilter: () => { }
};

export const WSTestingChipFilterContext = React.createContext<WSTestingChipFilterContextValue>(setFilter);

export const useWSTestingChipFilter = () => React.useContext(WSTestingChipFilterContext);
